// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 08-08-2025

import productActionTypes from './product.types';

/** ***************** ADD PRODUCT DETAILS START *********************** */
export const addProductDetailsStart = (addData: any) => ({
	type: productActionTypes.ADD_PRODUCT_DETAILS_START,
	payload: addData,
});

export const addProductDetailsSuccess = (successData: any) => ({
	type: productActionTypes.ADD_PRODUCT_DETAILS_SUCCESS,
	payload: successData,
});

export const addProductDetailsFailure = (failureData: any) => ({
	type: productActionTypes.ADD_PRODUCT_DETAILS_FAILURE,
	payload: failureData,
});

export const addProductDetailsResponseResetStart = () => ({
	type: productActionTypes.ADD_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const addProductDetailsResponseChanged = () => ({
	type: productActionTypes.ADD_PRODUCT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD PRODUCT DETAILS END *********************** */

/** ***************** UPDATE PRODUCT DETAILS START *********************** */
export const updateProductDetailsStart = (updateData: any) => ({
	type: productActionTypes.UPDATE_PRODUCT_DETAILS_START,
	payload: updateData,
});

export const updateProductDetailsSuccess = (successData: any) => ({
	type: productActionTypes.UPDATE_PRODUCT_DETAILS_SUCCESS,
	payload: successData,
});

export const updateProductDetailsFailure = (failureData: any) => ({
	type: productActionTypes.UPDATE_PRODUCT_DETAILS_FAILURE,
	payload: failureData,
});

export const updateProductDetailsResponseResetStart = () => ({
	type: productActionTypes.UPDATE_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const updateProductDetailsResponseChanged = () => ({
	type: productActionTypes.UPDATE_PRODUCT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE PRODUCT DETAILS END *********************** */

/** ***************** GET PRODUCT LIST START *********************** */
export const getProductListStart = (getData: any) => ({
	type: productActionTypes.GET_PRODUCT_LIST_START,
	payload: getData,
});

export const getProductListSuccess = (successData: any) => ({
	type: productActionTypes.GET_PRODUCT_LIST_SUCCESS,
	payload: successData,
});

export const getProductListFailure = (failureData: any) => ({
	type: productActionTypes.GET_PRODUCT_LIST_FAILURE,
	payload: failureData,
});

export const getProductListResponseResetStart = () => ({
	type: productActionTypes.GET_PRODUCT_LIST_RESPONSE_RESET,
});

export const getProductListResponseChanged = () => ({
	type: productActionTypes.GET_PRODUCT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET PRODUCT LIST END *********************** */

/** ***************** FETCH PRODUCT DETAILS START *********************** */
export const fetchProductDetailsStart = (fetchData: any) => ({
	type: productActionTypes.FETCH_PRODUCT_DETAILS_START,
	payload: fetchData,
});

export const fetchProductDetailsSuccess = (successData: any) => ({
	type: productActionTypes.FETCH_PRODUCT_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchProductDetailsFailure = (failureData: any) => ({
	type: productActionTypes.FETCH_PRODUCT_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchProductDetailsResponseResetStart = () => ({
	type: productActionTypes.FETCH_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const fetchProductDetailsResponseChanged = () => ({
	type: productActionTypes.FETCH_PRODUCT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH PRODUCT DETAILS END *********************** */

/** ***************** FETCH CUSTOM PRODUCT DETAILS START *********************** */
export const fetchCustomProductDetailsStart = (fetchData: any) => ({
	type: productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_START,
	payload: fetchData,
});

export const fetchCustomProductDetailsSuccess = (successData: any, productID?: any) => ({
	type: productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_SUCCESS,
	payload: { successData, productID },
});

export const fetchCustomProductDetailsFailure = (failureData: any) => ({
	type: productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchCustomProductDetailsResponseResetStart = () => ({
	type: productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const fetchCustomProductDetailsResponseChanged = () => ({
	type: productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH CUSTOM PRODUCT DETAILS END *********************** */

/** ***************** DELETE PRODUCT DETAILS START *********************** */
export const deleteProductDetailsStart = (deleteData: any) => ({
	type: productActionTypes.DELETE_PRODUCT_DETAILS_START,
	payload: deleteData,
});

export const deleteProductDetailsSuccess = (successData: any) => ({
	type: productActionTypes.DELETE_PRODUCT_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteProductDetailsFailure = (failureData: any) => ({
	type: productActionTypes.DELETE_PRODUCT_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteProductDetailsResponseResetStart = () => ({
	type: productActionTypes.DELETE_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const deleteProductDetailsResponseChanged = () => ({
	type: productActionTypes.DELETE_PRODUCT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE PRODUCT DETAILS END *********************** */

/** ***************** GET MATSER ACCOUNT LIST START *********************** */
export const getMasterAccountListStart = (getData: any) => ({
	type: productActionTypes.GET_MASTER_ACCOUNT_LIST_START,
	payload: getData,
});

export const getMasterAccountListSuccess = (successData: any) => ({
	type: productActionTypes.GET_MASTER_ACCOUNT_LIST_SUCCESS,
	payload: successData,
});

export const getMasterAccountListFailure = (failureData: any) => ({
	type: productActionTypes.GET_MASTER_ACCOUNT_LIST_FAILURE,
	payload: failureData,
});

export const getMasterAccountListResponseResetStart = () => ({
	type: productActionTypes.GET_MASTER_ACCOUNT_LIST_RESPONSE_RESET,
});

export const getMasterAccountListResponseChanged = () => ({
	type: productActionTypes.GET_MASTER_ACCOUNT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET MATSER ACCOUNT LIST END ************************/

/** ***************** GET ALL INSTRUMENT LIST START *********************** */
export const getAllInstrumnetListStart = (getData: any) => ({
	type: productActionTypes.GET_ALL_INSTRUMENT_LIST_START,
	payload: getData,
});

export const getAllInstrumnetListSuccess = (successData: any) => ({
	type: productActionTypes.GET_ALL_INSTRUMENT_LIST_SUCCESS,
	payload: successData,
});

export const getAllInstrumnetListFailure = (failureData: any) => ({
	type: productActionTypes.GET_ALL_INSTRUMENT_LIST_FAILURE,
	payload: failureData,
});

export const getAllInstrumnetListResponseResetStart = () => ({
	type: productActionTypes.GET_ALL_INSTRUMENT_LIST_RESPONSE_RESET,
});

export const getAllInstrumnetListResponseChanged = () => ({
	type: productActionTypes.GET_ALL_INSTRUMENT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET ALL INSTRUMENT LIST END *********************** */

/** ***************** FETCH FILTER PRODUCT LIST START *********************** */
export const fetchFilterProductListStart = (getData: any) => ({
	type: productActionTypes.FETCH_FILTER_PRODUCT_LIST_START,
	payload: getData,
});

export const fetchFilterProductListSuccess = (successData: any) => ({
	type: productActionTypes.FETCH_FILTER_PRODUCT_LIST_SUCCESS,
	payload: successData,
});

export const fetchFilterProductListFailure = (failureData: any) => ({
	type: productActionTypes.FETCH_FILTER_PRODUCT_LIST_FAILURE,
	payload: failureData,
});

export const fetchFilterProductListResponseResetStart = () => ({
	type: productActionTypes.FETCH_FILTER_PRODUCT_LIST_RESPONSE_RESET,
});

export const fetchFilterProductListResponseChanged = () => ({
	type: productActionTypes.FETCH_FILTER_PRODUCT_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH FILTER PRODUCT LIST END *********************** */

/** ***************** GET PRODUCT DETAILS LIST START *********************** */
export const getProductDetailsListStart = (getData: any) => ({
	type: productActionTypes.GET_PRODUCT_DETAILS_LIST_START,
	payload: getData,
});

export const getProductDetailsListSuccess = (successData: any) => ({
	type: productActionTypes.GET_PRODUCT_DETAILS_LIST_SUCCESS,
	payload: successData,
});

export const getProductDetailsListFailure = (failureData: any) => ({
	type: productActionTypes.GET_PRODUCT_DETAILS_LIST_FAILURE,
	payload: failureData,
});

export const getProductDetailsListResponseResetStart = () => ({
	type: productActionTypes.GET_PRODUCT_DETAILS_LIST_RESPONSE_RESET,
});

export const getProductDetailsListResponseChanged = () => ({
	type: productActionTypes.GET_PRODUCT_DETAILS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET PRODUCT DETAILS LIST END *********************** */
